import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import HeadingCard from "../../../newComponent/NewCardsComp/HeadingCard";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import MainCard from "../../../../components/Maincard";
import CustomAutocompleteComp from "../../../newComponent/AutocompleteComp";
import SearchButton from "../../../newComponent/NewButtonComp/SearchButton";
import ClearButtonComp from "../../../newComponent/NewButtonComp/ResetButtonComp";
import CustomSnackbar from "../../../components/ui-component/snackbar/CustomSnackbar";
import { useGetTokenOrLogout } from "../../../../utils/token";
import { useNavigate } from "react-router-dom";
import LoaderComp from "../../../newComponent/LoaderComp/Loader";
import CustomPopup from "../../../../components/CustomPopup";
import EventCounsellingDetailsData from "./EventCounsellingDetailsData";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function EventWiseUserCounsellingReport() {
  const [counsellingData, setCounsellingData] = useState([]);
  const userId = localStorage.getItem("userId");
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();
  const [eventName, setEventName] = useState(null);
  const [eventList, setEventList] = useState([]);
  const [eventLoading, setEventLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const noOptionsText = "Loading...";
  const [userList, setUserList] = useState([]);
  const [userName, setUserName] = useState([]);
  const [openPoup, setOpenPopup] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [detailsData, setDetailsData] = useState([]);

  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // Fetch event list
  useEffect(() => {
    const fetchData = async () => {
      setEventLoading(true);
      try {
        const response = await fetch(`${API_ENDPOINT}campaign/event/withname`);
        if (response.ok) {
          const data = await response.json();
          console.log("data", data);
          const filteredcampaign = data.filter(
            (campaign) => campaign.campaign_type_id?.id === 1
          );
          setEventList(filteredcampaign);
          setEventLoading(false);
          console.log("data1", filteredcampaign);
        } else {
          setEventLoading(false);
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        setEventLoading(false);
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // function to change event value

  const handleEventChange = (event, value) => {
    setEventName(value);
  };

  useEffect(() => {
    const fetchData = async () => {
      setEventLoading(true);
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/getAllUserByUserId/${userId}`
        );
        if (response.ok) {
          const data = await response.json();

          setUserList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [userId]);

  const newUserList = [{ first_name: "Select All" }, ...userList];
  const handleChangeUser = (e, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setUserName(userList);
    } else {
      setUserName(value);
    }
  };

  //  Function to search counselling data
  const handleSearchData = async (event) => {
    setLoading(true);

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      event_id: eventName?.id,
      user_id: parseInt(userId),
      emp_ids: userName.map((i) => i.user_id),
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}reports/getcounsellingreport`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();
      if (response.ok) {
        setLoading(false);

        setCounsellingData(result);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/page403");
      } else if (response.status === 400) {
        setLoading(false);
        showSnackbar(result.message, "error");
      } else {
        navigate("/page500");
      }
    } catch {
      navigate("/page500");
    }
  };

  // Function to reset Data
  const handleReset = () => {
    setEventName(null);
    setCounsellingData([]);
    setUserName([]);
  };

  const columns = [
    {
      field: "cunselling_by",
      headerName: "Counselling By",
      flex: 1,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.first_name || ""} ${params.row?.last_name || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.first_name} {params.row?.last_name}{" "}
        </div>
      ),
    },
    {
      field: "count",
      headerName: "Count",
      flex: 1,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography
          variant="h5"
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => handleCounsellingDetails(params?.row)}
        >
          {params.row?.count}
        </Typography>
      ),
    },
  ];

  const handleOpenPoup = (rowData) => {
    setOpenPopup(true);
  };

  const handleClosePopup = (rowData) => {
    setOpenPopup(false);
  };

  //  Function to search counselling data
  const handleCounsellingDetails = async (rowData) => {
    console.log("rowData", rowData?.user_id);
    setDetailsLoading(true);

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      event_id: eventName?.id,
      user_id: parseInt(userId),
      counselling_by: rowData?.user_id,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}reports/getcounsellingreport-with-detals`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();
      if (response.ok) {
        setDetailsLoading(false);

        setDetailsData(result);
        handleOpenPoup(rowData);
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
        setDetailsData([]);
        setDetailsLoading(false);
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
        setDetailsData([]);
        setDetailsLoading(false);
      } else if (response.status === 400) {
        setDetailsData([]);
        setDetailsLoading(false);
        showSnackbar(result.message, "error");
      } else {
        showSnackbar("Server Error", "error");
        setDetailsData([]);
        setDetailsLoading(false);
      }
    } catch {
      showSnackbar("Server Error", "error");
      setDetailsData([]);
      setDetailsLoading(false);
    }
  };

  return (
    <>
      <LoaderComp isLoading={loading || detailsLoading} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={3}>
          <HeadingCard label="Counselling Report" />
        </Grid>
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={4} md={4} sm={8}>
                <Typography variant="h5">Event</Typography>

                <CustomAutocompleteComp
                  size="small"
                  disableClearable
                  value={eventName}
                  noOptionsText={
                    eventLoading && eventList.length === 0 ? noOptionsText : ""
                  }
                  onChange={handleEventChange}
                  options={eventList}
                  getOptionLabel={(option) => option.campaign_name}
                />
              </Grid>

              <Grid item xs={12} lg={4} md={4} sm={8}>
                <Typography variant="h5">Select User</Typography>

                <CustomAutocompleteComp
                  size="small"
                  value={userName}
                  multiple
                  onChange={handleChangeUser}
                  options={newUserList}
                  getOptionLabel={(option) =>
                    `${option.first_name ? option.first_name : ""} ${
                      option.last_name ? option.last_name : ""
                    }`
                  }
                  tooltipContent={(option) =>
                    `${option.first_name ? option.first_name : ""} ${
                      option.last_name ? option.last_name : ""
                    }`
                  }
                />
              </Grid>

              <Grid item xs={12} lg={4} md={4} sm={4}>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    visibility: "hidden",
                  }}
                >
                  Event
                </Typography>
                <Grid container gap={1}>
                  <SearchButton label="Search" onClick={handleSearchData} />

                  <ClearButtonComp label="Reset" onClick={handleReset} />
                </Grid>
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
        <Grid item xs={12}>
          <Grid item xs={12}>
            <MainCard>
              <DataGrid
                rows={counsellingData}
                columns={columns}
                autoHeight
                slots={{
                  noRowsOverlay: CustomNoRowsOverlay,
                }}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 25,
                    },
                  },
                }}
                pageSizeOptions={[25, 50, 100]}
                disableRowSelectionOnClick
              />
            </MainCard>
          </Grid>
        </Grid>
      </Grid>

      <CustomPopup
        open={openPoup}
        onClose={handleClosePopup}
        title="View Counseling Details"
        component={
          <EventCounsellingDetailsData
            onClose={handleClosePopup}
            detailsData={detailsData}
          />
        }
        maxWidth="lg"
        showDivider={true}
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
